<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
body {
  background: #fef1e0;
  margin: 0%;
  overflow-x: hidden;
}
</style>
